import 'lazysizes'
import ready from 'document-ready'
import StartingBlocks, { History, Pjax, Prefetch } from 'starting-blocks'
import WebpackAsyncBlockBuilder from './services/WebpackAsyncBlockBuilder'

// factories
import TransitionFactory from './factories/TransitionFactory'

// import pages
import DefaultPage from './pages/DefaultPage'

// import common components
import DebugGrid from './common/DebugGrid'
import Nav from './common/Nav'

// import blocks
import DummyBlock from './blocks/DummyBlock'

// import polyfills
import polyfills from './utils/polyfills'

// execute polyfills
polyfills()

function letsRoll() {
  let sbConfig = {}

  if (process.env.MIX_MOODLEY_DEVELOPMENT) {
    sbConfig = {
      ...sbConfig,
      debug: 1, // uses console.debug; set the browser log level to verbose to see them
    }
  }

  let sb = new StartingBlocks(sbConfig)

  // Custom block builder (dynamic import) - not working atm
  // sb.provider('BlockBuilder', WebpackAsyncBlockBuilder)

  // Providers for page transitions
  sb.provider('History', History)
  sb.provider('TransitionFactory', TransitionFactory)
  sb.bootableProvider('Pjax', Pjax)
  sb.bootableProvider('Prefetch', Prefetch)

  // For each page or block sections: you must map the service name
  // with the data-node-type attribute (see DOM Structure section).
  // «c» parameter stands for Starting-Blocks service container

  // Register page services factory
  sb.instanceFactory('DefaultPage', c => {
    return new DefaultPage(c)
  })

  // Register block services factory
  sb.instanceFactory('DummyBlock', c => {
    return new DummyBlock(c)
  })

  const nav = new Nav()
  let debugGrid
  if (process.env.MIX_MOODLEY_DEVELOPMENT) {
    debugGrid = new DebugGrid()
  }

  // 🚀 Boot the whole thing
  sb.boot()

  nav.init()

  if (process.env.MIX_MOODLEY_DEVELOPMENT) {
    debugGrid.init()
  }
}

ready(letsRoll)
